window.carousel = window.carousel || {};

carousel.cacheSelectors = function () {
  carousel.cache = {
    // Feature
    $feature_carousel: $('.feature-slider'),

    // What's New
    $product_carousel: $('.product-slider')
  }
};

carousel.init = function () {
  carousel.cacheSelectors();
  carousel.feature_slider();
  carousel.product_slider();
};

carousel.feature_slider = function () {
  var $feature_carousel = carousel.cache.$feature_carousel,
      carouselArgs = {
        // transitionStyle: 'slide',
        stopOnHover: true,
        autoplay: true,
        autoplaySpeed: 7000,
        cssEase: 'ease-out',
        
        dots: false,
        nextArrow: '<button type="button" data-role="none" class="slick-next icon-slider-arrow-right icon-alone" aria-label="Next" role="button">Next</button>',
        prevArrow: ''
      };

  $feature_carousel
    .on('init', function(event, slick) {
      if ( Modernizr.mq('(min-width: 480px)') ) {
        $feature_carousel.find('.slide-image').imagefill();
      }
    })
    .slick(carouselArgs);
};

carousel.product_slider = function () {
  var $product_carousel = carousel.cache.$product_carousel,
      carouselArgs = {
        stopOnHover: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        speed: 300,
        cssEase: 'ease-out',
        nextArrow: '<button type="button" data-role="none" class="slick-next icon-slider-arrow-right icon-alone" aria-label="Next" role="button">Next</button>',
        prevArrow: '<button type="button" data-role="none" class="slick-prev icon-slider-arrow-left icon-alone" aria-label="Prev" role="button">Prev</button>',
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      };

  $product_carousel.slick(carouselArgs);
};

// Initialize slider on docready
$(window).on('load', function() {
  carousel.init();
});
